<template>
    <v-btn icon light @click="markActivity()">
        <v-icon v-if="marked" color="primary" >check</v-icon>
        <v-icon v-else color="primary lighten-3" >check</v-icon>
    </v-btn>
</template>

<script>
export default {
  data() {
    return {
      marked: false
    };
  },
  methods: {
    markActivity() {
      this.marked = !this.marked;
      this.$emit("activitymarked");
    }
  }
};
</script>
